import { render, staticRenderFns } from "./InsuranceTargetCard.vue?vue&type=template&id=0ca8c723&scoped=true"
import script from "./InsuranceTargetCard.vue?vue&type=script&lang=js"
export * from "./InsuranceTargetCard.vue?vue&type=script&lang=js"
import style0 from "./InsuranceTargetCard.vue?vue&type=style&index=0&id=0ca8c723&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca8c723",
  null
  
)

export default component.exports